import React from 'react';
import { useQuery } from '@apollo/client';
import { Loader } from '../../../../components/Loader';
import Navbar from '../../../../components/Navbar';
import { PerFYDeviceRefreshReport as PerFYReport } from '../api';

import ReactTable from 'react-table';
import { Form } from 'react-bootstrap';

export const PerFYDeviceRefreshReport = (props: any) => {
  // const [gridLoading, setGridLoading] = React.useState(false);
  const [refreshYear, setRefreshYear] = React.useState<string>(String(new Date().getFullYear()).substring(2));
  const date = new Date();
  const currentFY = date.getMonth() < 6 ? String(date.getFullYear()).substring(2) : String(date.getFullYear() + 1).substring(2);
  const { loading, error, data, refetch } = useQuery(PerFYReport, {
    variables: {
      year: Number(currentFY),
    },
  });

  // React.useEffect(() => {
  //   <Loader/>
  // }, [gridLoading])

  const getRefreshYears = (currentYear: string) => {
    let refreshYears = [];
    let year = Number(currentYear);
    for (let i = 0; i < 5; i++) {
      refreshYears.push(String(year));
      year += 1;
    }
    return refreshYears;
  };

  const fetch = (target: any) => {
    setTimeout(() => {
      try {
        refetch({
          year: target,
        });
      } catch (e) {
        alert('Error with FY change, try again.');
        window.location.reload();
      }
    }, 1000);
  };

  let refreshYears = getRefreshYears(currentFY);

  const renderGrid = (noTotals: any) => {
    const totalColumns = [
      {
        Header: 'Department Name',
        accessor: 'departmentName',
        minWidth: 100,
        Footer: 'Totals of all Departments',
      },
      {
        Header: '# of Desktops to Refresh',
        accessor: 'Desktops',
        Footer: data.getUpcomingRefreshReportv2[data.getUpcomingRefreshReportv2.length - 1].Desktops.toString(),
      },
      {
        Header: '# of Laptops to Refresh',
        accessor: 'Laptops',
        Footer: data.getUpcomingRefreshReportv2[data.getUpcomingRefreshReportv2.length - 1].Laptops.toString(),
      },
      {
        Header: '# of Tablets to Refresh',
        accessor: 'Tablets',
        Footer: data.getUpcomingRefreshReportv2[data.getUpcomingRefreshReportv2.length - 1].Tablets.toString(),
      },
      {
        Header: '# of iPads to Refresh',
        accessor: 'iPads',
        Footer: data.getUpcomingRefreshReportv2[data.getUpcomingRefreshReportv2.length - 1].iPads.toString(),
      },
      {
        Header: 'FY',
        width: 100,
        accessor: 'Refresh_FY',
      },
    ];

    return (
      <ReactTable
        pageSize={data.getUpcomingRefreshReportv2.length - 1}
        columns={totalColumns}
        filterable
        resizable
        showPagination={false}
        className='-striped -highlight mb-5'
        data={noTotals}
      />
    );
  };

  if (loading) {
    return (
      <React.Fragment>
        <Navbar />
        <Loader />
      </React.Fragment>
    );
  }
  if (error) {
    return (
      <React.Fragment>
        <Navbar />
        <h2>Error loading data...</h2>
      </React.Fragment>
    );
  }
  if (data) {
    let noTotalsData = data.getUpcomingRefreshReportv2.slice(0, data.getUpcomingRefreshReportv2.length - 1);
    
    return (
      <React.Fragment>
        <Navbar />
        <div className='container-fluid mt-1'>
          <div className='row mt-2 mb-2'>
            <div className='col-sm-6'>
              <h2>Per FY Refresh Report</h2>
            </div>
            <div className='col-sm-6'>
              <Form inline className='float-right'>
                <Form.Group>
                  <Form.Label className='mr-1'>Upcoming Device Refresh for FY:</Form.Label>
                  <Form.Control
                    as='select'
                    name='inventoryYear'
                    onChange={(e: any) => {
                      fetch(Number(e.target.value));
                      setRefreshYear(e.target.value);
                    }}
                    defaultValue={refreshYear}>
                    {refreshYears.map((item, index) => (
                      <option key={index} value={item}>
                        20{item}
                      </option>
                    ))}
                    <option key={-1} value={-1}>
                      All
                    </option>
                  </Form.Control>
                </Form.Group>
              </Form>
            </div>
          </div>
          {renderGrid(noTotalsData)}
        </div>
      </React.Fragment>
    );
  }
};
